module.exports = __webpack_public_path__ + "static/park_map_roads-cd2191ac616b9ef0680bcccdc369b3db.svg";